module.exports = __webpack_public_path__ + "static/img/pCT8.e236b50b.png";